export const EVENTS = {
  CLEAR: 'CLEAR',
};
